import {FadePresence} from 'nf-ui'
import React from 'react'
import styled from 'styled-components'
import {WizardLayout} from './WizardLayout'

const PageContainer = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: row;
    > * {
        width: 50%;
    }
    @media (max-width: 1170px) {
        flex-direction: column;
        > * {
            width: 100%;
        }
    }
`

const Body = styled.div`
    max-width: 440px;
    padding-left: 120px;
    @media (max-width: 1170px) {
        padding-left: 32px;
        padding-right: 32px;
    }
    @media (max-width: 479px) {
        padding-left: 24px;
        padding-right: 24px;
    }
`

export const WelcomeLaout: React.FC = ({children}) => {
    return (
        <PageContainer>
            <WizardLayout>
                <WizardLayout.Navigation />
                <FadePresence exitBeforeEnter>
                    <Body>{children}</Body>
                </FadePresence>
            </WizardLayout>
        </PageContainer>
    )
}
